import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import config from "../../config/config";
// import {
//   CLEANUP_MESSAGE,
//   ERROR_MESSAGE,
//   SUCCESS_MESSAGE,
// } from "../../common/Constant";
// import { toastSuccess } from "../../common/Toast";

const ClearDataPayBill = (
 {handleYes}
) => {


  const handleOk = () => {
    // handleCompleteSale();
    // navigate(`/sales-receipt`);
    handleYes()
  };

  return (
    <>
      <div
        className="modal fade"
        id="ClearDataPayBill"
        tabIndex={-1}
        aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        style={{background: 'rgba(0,0,0, 0.4)'}}
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Warning</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h6>
                  "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"                  </h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={handleOk}
              >
                Leave Changes
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClearDataPayBill;
